import { render, staticRenderFns } from "./WhatsappChatStarter.vue?vue&type=template&id=0fd5ae38&scoped=true"
import script from "./WhatsappChatStarter.vue?vue&type=script&lang=js"
export * from "./WhatsappChatStarter.vue?vue&type=script&lang=js"
import style0 from "./WhatsappChatStarter.vue?vue&type=style&index=0&id=0fd5ae38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd5ae38",
  null
  
)

export default component.exports